import styled from 'styled-components';
import { ContainerV2 } from '../../../../../../stories/atoms/containerV2/ContainerV2';
import { ProgressIndicatorStatus } from '../../../../common/metricTile/WidgetMetricTile';
import { getIndicatorColors } from '../../../../common/metricTile/WidgetMetricTile.styles';

export const StyledForecastCard = styled(ContainerV2)<{ indicator: ProgressIndicatorStatus | null }>`
  background-color: ${({ theme: { palette, color }, indicator }) =>
    indicator
      ? getIndicatorColors(indicator, palette.mode).backgroundColor
      : palette.mode === 'dark'
      ? color.backgroundPaperDark
      : color.white};
`;
